import { State, StateContext, Action, Selector } from '@ngxs/store';
import {
  Login,
  Logout,
  CheckMobileNumber,
  SetLoginStatus,
  Register,
} from './auth.actions';
import { map, tap } from 'rxjs';
import { Injectable } from '@angular/core';

export interface AuthStateModel {
  countrycode: string | null;
  mobileNumber: string | null;
  username: string | null;
  email: string | null;
  token: string | null;
  loginStatus: LoginStatus;
}

export enum LoginStatus {
  notLoggedIn = 0,
  needRegistration = 1,
  needOTP = 2,
}

@Injectable()
@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    countrycode: null,
    mobileNumber: null,
    username: null,
    email: null,
    token: null,
    loginStatus: LoginStatus.notLoggedIn,
  },
})
export class AuthState {
  constructor() {} // private authService: AuthService

  @Selector()
  static token(state: AuthStateModel) {
    return state.token;
  }

  @Selector()
  static isAuthenticated(state: AuthStateModel) {
    return !!state.token;
  }

  @Selector()
  static mobileNumber(state: AuthStateModel) {
    return state.mobileNumber;
  }

  @Selector()
  static countryCode(state: AuthStateModel) {
    return state.countrycode;
  }

  @Selector()
  static loginStatus(state: AuthStateModel) {
    return state.loginStatus;
  }

  @Action(CheckMobileNumber)
  checkMobileNumber(
    ctx: StateContext<AuthStateModel>,
    action: CheckMobileNumber
  ) {
    // return this.authService.checkMobileNumber(action.payload).pipe(
    //   map((result) => result.data),
    //   tap((result) => {
    //     ctx.patchState({
    //       countrycode: action.payload.countryCode,
    //       mobileNumber: action.payload.mobileNumber,
    //     });
    //   })
    // );
  }

  @Action(Login)
  login(ctx: StateContext<AuthStateModel>, action: Login) {
    // return this.authService.login(action.payload).pipe(
    //   map((result) => result.data),
    //   tap((result) => {
    //     ctx.patchState({
    //       username: result.userName,
    //       token: result.token,
    //     });
    //   })
    // );
  }

  @Action(Register)
  register(ctx: StateContext<AuthStateModel>, action: Register) {
    // return this.authService.register(action.payload).pipe(
    //   map((result) => result.data),
    //   tap((result) => {
    //     ctx.patchState({
    //       mobileNumber: action.payload.mobileNumber,
    //       countrycode: action.payload.countryCode,
    //       email: action.payload.email,
    //       username: action.payload.name,
    //     });
    //   })
    // );
  }

  @Action(Logout)
  logout(ctx: StateContext<AuthStateModel>) {
    ctx.setState({
      countrycode: null,
      mobileNumber: null,
      username: null,
      email: null,
      token: null,
      loginStatus: LoginStatus.notLoggedIn,
    });
  }

  @Action(SetLoginStatus)
  setLoginStatus(ctx: StateContext<AuthStateModel>, action: SetLoginStatus) {
    ctx.patchState({
      loginStatus: action.payload,
    });
  }
}
